import React from "react";
import { Input, Form } from "antd";
import { Controller } from "react-hook-form";
import Label from "../Label";
import { getError } from "../../utils/form";
import "./style.css";

const itemLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

/* const styles = {
  textBox: {
    minHeight: "3.75vw",
    border: "1px solid",
    borderColor: "#f3f4f5",
    backgroundColor: "#eff3f7",
    borderRadius: 4,
    fontFamily: "DM Sans",
    flexGrow: 1,
    padding: "0 16px",
    height: "auto",
    width: "100%",
    marginTop: 10,
    marginBottom: 5,
  },
};
 */
const ControlledInputBox = ({
  control,
  errors,
  name,
  label,
  required,
  type = "text",
  placeholder,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          {...itemLayout}
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
          style={{ marginBottom: 10 }}
        >
          <Label name={name} text={label} required={required} />
          <Input
            type={type}
            {...field}
            placeholder={placeholder}
            //style={styles.textBox}
            className="textBox"
            onFocus={() => {
              let el = document.getElementsByName(name);
              el = el[0];
              el.setAttribute("autocomplete", "autocomplete_off");
              //el.setAttribute("id", `${label}_`);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

export default ControlledInputBox;
